import ModalCampaignHeJEligible from "./estagio/campanhas-especiais/henrique-juliano/ModalCampaignHeJEligible";
import ModalCampaignHeJNotEligible from "./estagio/campanhas-especiais/henrique-juliano/ModalCampaignHeJNotEligible";
import ModalCampaignHeJRequest from "./estagio/campanhas-especiais/henrique-juliano/ModalCampaignHeJRequest";
import ModalCampaignHeJResponse from "./estagio/campanhas-especiais/henrique-juliano/ModalCampaignHeJResponse";
import ModalCampaignKFEligible from "./estagio/campanhas-especiais/kamilla-fialho/ModalCampaignKFEligible";
import ModalCampaignKFNotEligible from "./estagio/campanhas-especiais/kamilla-fialho/ModalCampaignKFNotEligible";
import ModalCampaignKFRequest from "./estagio/campanhas-especiais/kamilla-fialho/ModalCampaignKFRequest";
import ModalCampaignKFResponse from "./estagio/campanhas-especiais/kamilla-fialho/ModalCampaignKFResponse";
import ModalCampaignADEligible from "./estagio/campanhas-especiais/anno-domini/ModalCampaignADEligible";
import ModalCampaignADNotEligible from "./estagio/campanhas-especiais/anno-domini/ModalCampaignADNotEligible";
import ModalCampaignADRequest from "./estagio/campanhas-especiais/anno-domini/ModalCampaignADRequest";
import ModalCampaignADResponse from "./estagio/campanhas-especiais/anno-domini/ModalCampaignADResponse";

const Modais = {
  ModalCampaignHeJEligible,
  ModalCampaignHeJNotEligible,
  ModalCampaignHeJRequest,
  ModalCampaignHeJResponse,
  ModalCampaignKFEligible,
  ModalCampaignKFNotEligible,
  ModalCampaignKFRequest,
  ModalCampaignKFResponse,
  ModalCampaignADEligible,
  ModalCampaignADNotEligible,
  ModalCampaignADRequest,
  ModalCampaignADResponse,
};

export default Modais;
